export const EXCLUDE_TRANSFORM_MAPPING = [
  "e_cblp",
  "e_cp",
  "e_crlc",
  "e_cparhdr",
  "e_minalloc",
  "e_maxalloc",
  "e_ss",
  "e_sp",
  "e_csum",
  "e_ip",
  "e_cs",
  "e_lfarlc",
  "e_ovno",
  "e_res",
  "e_oemid",
  "e_oeminfo",
  "e_res2",
  "e_lfanew"
];

export const FIELD_NAME_MAPPINGS = {
  size: "Size",
  sha1: "SHA1",
  sha256: "SHA256",
  sha384: "SHA384",
  sha512: "SHA512",
  md5: "MD5",
  crc32: "CRC32",
  nfc: "NFC",
  vpn: "VPN"
};

/* eslint-enable no-bitwise */

export const CATEGORIES = {
  other: 0,
  application: 1,
  mobile: 2,
  document: 3,
  web: 4,
  archive: 5,
  media: 6
};
